import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import AOS from "aos";
import "aos/dist/aos.css";

export const Faq = () => {

useEffect(() => {
    AOS.init({
        duration: 1500,
        once: true,
        disable: function () {
            return window.innerWidth < 992;
        },
    });
}, []);
   
return(
<div className="page-content servicepage">
    <section className="wi_full py_3 inner_banner" style={{backgroundImage: "url('./images/faq-banner.jpg')",backgroundSize: "cover",
        backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
        <div className="container" data-aos="fade-in">
            <h1>FAQs</h1>
        </div>
    </section>
    <section className="faq_acc_sec wi_full">
        <div className="faq_acc_block py_3">
            <div className="container" data-aos="fade-up">
                <div className="row accordion_wrapper">
                    <div className="col-lg-6 accr_col align-self-center">
                        <div className="sec_title">
                            <h2>FAQs</h2>
                            <p>FAQs- site should only show the question with plus sign to expand for answer</p> 
                        </div>
                        <div className="accordion" id="accordionLeft">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="leftOne">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">What is health insurance and why do I need it?</button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="leftOne" data-bs-parent="#accordionLeft">
                                    <div className="accordion-body"> 
                                        <p>Health insurance helps cover the cost of medical care, including doctor visits, hospital stays, prescriptions, preventive services, and more. It protects you from high, unexpected healthcare expenses and gives you access to essential care.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="leftTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">What types of health insurance do you offer?</button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="leftTwo" data-bs-parent="#accordionLeft">
                                    <div className="accordion-body"> 
                                        <p>We specialize in:</p>
                                        <p><strong>Individual & Family Plans (IHC) –</strong> Coverage for those not covered through an employer.</p>
                                        <p><strong>Medicare Plans –</strong> Medicare Advantage, Supplements (Medigap), and Part D prescription drug plans.</p>
                                        <p><strong>Short-Term & Supplemental Plans –</strong> Affordable gap coverage for transitions or limited needs.</p>
                                        <p><strong>Dental, Vision & Life Insurance –</strong> Optional add-ons for complete protection.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="leftThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">What types of health insurance do you offer?</button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="leftThree" data-bs-parent="#accordionLeft">
                                    <div className="accordion-body">
                                        <p>IHC plans are private individual health coverage, often outside the ACA exchange, offering flexibility and variety. ACA plans, found on Healthcare.gov or your state exchange, follow government rules on essential health benefits and subsidies. We help clients compare both options.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="leftFour">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">What is the difference between IHC and Marketplace/ACA plans?</button>
                                </h2>
                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="leftFour" data-bs-parent="#accordionLeft">
                                    <div className="accordion-body">
                                        <p>Yes! We’re licensed and certified to help individuals and families find coverage in all 50 states. Whether you're shopping for IHC, Medicare, or supplemental plans, we’ve got you covered.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="leftFive">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">Do you offer coverage in all states?</button>
                                </h2>
                                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="leftFive" data-bs-parent="#accordionLeft">
                                    <div className="accordion-body">
                                        <p><strong>IHC Plans:</strong> Enrollment is often open year-round in many states.</p>
                                        <p><strong>ACA Plans:</strong> Generally require enrollment during Open Enrollment or if you qualify for a Special Enrollment Period (SEP).</p>
                                        <p><strong>Medicare:</strong> Annual Enrollment Period is Oct 15 – Dec 7, with other options depending on your situation.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 img_col mt-4 mt-lg-0">
                        <img src="./images/faq-img-1.jpg" alt="#" className="w-100" />
                    </div>
                </div>
            </div>
        </div>
        <div className="faq_acc_block py_3">
            <div className="container" data-aos="fade-up">
                <div className="row accordion_wrapper flex-lg-row-reverse">
                    <div className="col-lg-6 accr_col align-self-center">
                        <div className="accordion" id="accordionRight">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rightFive">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Five">Can I enroll at any time?</button>
                                </h2>
                                <div id="collapse_right_Five" className="accordion-collapse collapse" aria-labelledby="rightFive" data-bs-parent="#accordionRight">
                                    <div className="accordion-body"> 
                                        <p><strong>Deductible:</strong> What you pay before insurance kicks in.</p>
                                        <p><strong>Copay:</strong> A set fee for specific services (e.g., $20 for a doctor visit).</p>
                                        <p><strong>Out-of-pocket max:</strong> The most you'll pay in a year before insurance covers 100%.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rightOne">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_One">How much does health insurance cost?</button>
                                </h2>
                                <div id="collapse_right_One" className="accordion-collapse collapse" aria-labelledby="rightOne" data-bs-parent="#accordionRight">
                                    <div className="accordion-body">
                                        <p>Costs vary based on your age, location, coverage level, and eligibility for subsidies. We provide personalized quotes and help you find the most cost-effective plans for your needs.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rightTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Two">What if I have a pre-existing condition?</button>
                                </h2>
                                <div id="collapse_right_Two" className="accordion-collapse collapse" aria-labelledby="rightTwo" data-bs-parent="#accordionRight">
                                    <div className="accordion-body"> 
                                        <p>All ACA-compliant and most IHC plans cover pre-existing conditions. If you’re unsure, we’ll walk you through which plans are best for you.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rightThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Three">What is Medicare and when can I enroll?</button>
                                </h2>
                                <div id="collapse_right_Three" className="accordion-collapse collapse" aria-labelledby="rightThree" data-bs-parent="#accordionRight">
                                    <div className="accordion-body">
                                        <p>Medicare is federal health coverage for:</p>
                                        <p>People 65 and older</p>
                                        <p>Certain younger individuals with disabilities</p>
                                        <p>You can enroll:</p>
                                        <p>At age 65 (Initial Enrollment)</p>
                                        <p>During the Annual Enrollment Period (Oct 15 – Dec 7)</p>
                                        <p>Or during a Special Enrollment Period (e.g., after retirement)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="rightFour">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_right_Four">How can you help me?</button>
                                </h2>
                                <div id="collapse_right_Four" className="accordion-collapse collapse" aria-labelledby="rightFour" data-bs-parent="#accordionRight">
                                    <div className="accordion-body"> 
                                        <p>We’re licensed brokers working for you — not the insurance companies. Our services include:</p>
                                        <p>Comparing plans from top carriers</p>
                                        <p>Explaining benefits in plain language</p>
                                        <p>Ensuring you're not overpaying</p>
                                        <p>Assisting with applications & renewals</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 img_col mt-4 mt-lg-0">
                        <img src="./images/faq-img-2.jpg" alt="#" className="w-100" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Partner />
</div>
)
}